import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { texts } from './footer.texts';

@Component({
  standalone: false,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

export class FooterComponent implements OnInit {

  @Input()
  background : string;

  @Input()
  language: 'de' | 'en' = 'de';

  texts = texts;

  currentDate = new Date();
  
  ngOnInit() {
  }


}
